import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "../../../../design_system/transitions"

export default class extends Controller {
  static targets = ["sidebar", "content", "label", "popoverContent"]

  static values = {
    expanded: { type: Boolean, default: false },
    storageKey: { type: String, default: "bo_main_sidebar_expanded" },
    labelHideClass: String,
    popoverContentHideClasses: { type: Array, default: [] },
    removeAnimationClass: String
  }

  connect() {
    this.animatableElements = this.element.querySelectorAll('[data-expanded-classes], [data-collapsed-classes]')
    this.expandedValue = localStorage.getItem(this.storageKeyValue) === "true"
    this.applyState(false)
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    localStorage.setItem(this.storageKeyValue, this.expandedValue)
    this.applyState(true)
  }

  applyState(animate) {
    if (!this.hasSidebarTarget) return

    if (!animate) {
      this.animatableElements.forEach(el => el.classList.add(this.removeAnimationClassValue))
      this.labelTargets.forEach(label => label.classList.add(this.removeAnimationClassValue))
    }

    this.animatableElements.forEach(el => {
      if (this.expandedValue) {
        el.classList.remove(...JSON.parse(el.dataset.collapsedClasses))
        el.classList.add(...JSON.parse(el.dataset.expandedClasses))
      } else {
        el.classList.remove(...JSON.parse(el.dataset.expandedClasses))
        el.classList.add(...JSON.parse(el.dataset.collapsedClasses))
      }
    })

    this.labelTargets.forEach(label => {
      if (this.expandedValue) {
        animate ? enter(label) : label.classList.remove(this.labelHideClassValue)
      } else {
        animate ? leave(label) : label.classList.add(this.labelHideClassValue)
      }
    })

    this.togglePopovers()

    if (!animate) {
      requestAnimationFrame(() => {
        this.animatableElements.forEach(el => el.classList.remove(this.removeAnimationClassValue))
        this.labelTargets.forEach(label => label.classList.remove(this.removeAnimationClassValue))
      })
    }
  }

  togglePopovers() {
    this.popoverContentTargets.forEach(el => {
      this.popoverContentHideClassesValue.forEach(cls => el.classList.toggle(cls, this.expandedValue))
    })
  }
}
